import {
  IGetAllRolesRequest,
  ICreateUpdateRoleRequest,
  IDeleteRoleRequest,
} from '../../types/api/request/rolesandpermissionsrequest';
import {
  ICreateUpdateRoleResponse,
  IGetAllRolesResponse,
} from '../../types/api/response/rolesandpermissionresponse';
import axiosClient from '../axiosClient';
import { RolesAndPermissionsEndpoints } from '../endpoints/rolesAndPermissions';

export const RolesAndPermissionsService = {
  async getAllRoles(payload?: IGetAllRolesRequest): Promise<IGetAllRolesResponse> {
    const params = payload ? `?page=${payload?.page}&size=${payload?.size}` : ``;
    const res = await axiosClient.get<IGetAllRolesResponse>(
      `${RolesAndPermissionsEndpoints.GET_ALL_ROLES}${params}`,
    );

    return res.data;
  },

  async createRole(payload: ICreateUpdateRoleRequest): Promise<ICreateUpdateRoleResponse> {
    const res = await axiosClient.post<ICreateUpdateRoleResponse>(
      `${RolesAndPermissionsEndpoints.GET_ALL_ROLES}`,
      payload,
    );

    return res.data;
  },

  async updateRole(payload: ICreateUpdateRoleRequest) {
    const res = await axiosClient.put(RolesAndPermissionsEndpoints.UPDATE_ROLE, payload);
    return res.data;
  },

  async deleteRole(id: number): Promise<void> {
    const payload: IDeleteRoleRequest = { id };
    const res = await axiosClient.delete(RolesAndPermissionsEndpoints.DELETE_ROLE, {
      data: payload,
    });
    return res.data;
  },
};
